import React from 'react';
import PropTypes from 'prop-types';
import Collapsable from '../Collapsable/Collapsable';
import styles from './Navigation.scss';
import { Link } from 'react-scroll';
import classNames from 'classnames';
import _ from 'lodash';
import { Text } from 'wix-style-react';

export default class Navigation extends React.PureComponent {
  static propTypes = {
    tree: PropTypes.object,
    collapse: PropTypes.bool,
    onSelect: PropTypes.func,
    selectedSection: PropTypes.string,
    selectedLeaf: PropTypes.string,
  };

  static defaultProps = {
    currentRoute: [],
    onSelect: () => {},
  };

  render() {
    const rootLevel = this._getRootLevel();
    return <div className={styles.wrapper}>{rootLevel}</div>;
  }

  getFirstMenu = () => {
    return this.props.tree[Object.keys(this.props.tree)[0]];
  };

  getFirstSectionFromMenu = menu => {
    if (_.isEmpty(menu) || _.isEmpty(menu.children)) {
      return {};
    }

    return menu.children[Object.keys(menu.children)[0]];
  };

  getSelectedSection() {
    return this.props.selectedSection || this.getFirstMenu().id;
  }

  getSelectedLeaf() {
    return this.props.selectedLeaf || this.getFirstSectionFromMenu(this.getFirstMenu()).id;
  }

  _getRootLevel = () => {
    const { tree } = this.props;
    return tree ? Object.keys(tree).map(this._getRoot) : null;
  };

  _getRoot = (node, id) => {
    const { tree, collapse } = this.props;
    const isSelected = this.getSelectedSection() === tree[node].id && !collapse;
    const nodeDef = tree[node];
    const weightType = isSelected ? 'bold' : 'normal';
    return nodeDef ? (
      <div key={id} className={`${styles.rootLevel} ${isSelected ? styles.selected : ''}`} data-hook="navigation-menu">
        <Link
          offset={-5}
          smooth={true}
          duration={200}
          onClick={this._onSelectRoot}
          containerId={'scroll-container'}
          activeClass="active"
          to={nodeDef.id}
        >
          <div className={styles.label} id={nodeDef.id} data-node={nodeDef.id} data-hook="navigation-menu-title">
            <Text size="medium" weight={weightType}>
              {nodeDef.label}
            </Text>
          </div>
        </Link>
        <Collapsable isOpen={isSelected}>
          <div className={styles.children} data-hook="navigation-sections">
            {this._getChildren(nodeDef.children, nodeDef.id)}
            <div className={styles.bar} />
          </div>
        </Collapsable>
      </div>
    ) : null;
  };

  _getChildren = (tree, parentNode) => {
    const selectedKey = this.getSelectedLeaf();
    return tree
      ? Object.keys(tree).map((node, id) =>
          tree[node] ? (
            <Link
              key={id}
              offset={-5}
              smooth={true}
              duration={200}
              onClick={this._onSelectLeaf}
              containerId={'scroll-container'}
              activeClass="active"
              to={tree[node].id}
            >
              <div
                ref={this._leafRef}
                data-parent={parentNode}
                data-node={tree[node].id}
                className={`${styles.leaf} ${selectedKey === tree[node].id ? styles.selected : ''}`}
                onClick={this._onSelectLeaf}
                data-hook="navigation-section-item"
              >
                <div
                  className={classNames([styles.indicator, selectedKey === tree[node].id && styles.indicatorSelected])}
                />
                <div className={styles.leafText}>
                  <Text
                    size="small"
                    tagName="div"
                    weight={selectedKey === tree[node].id ? 'bold' : 'normal'}
                    secondary={selectedKey !== tree[node].id}
                    className={selectedKey === tree[node].id ? styles.smallSpacing : styles.largeSpacing}
                  >
                    {tree[node].label}
                  </Text>
                </div>
              </div>
            </Link>
          ) : null,
        )
      : null;
  };

  _onSelectRoot = e => {
    const { onSelect, tree } = this.props;
    const node = e.target.closest(`.${styles.label}`).getAttribute('data-node');
    onSelect({ selectedSection: tree[node].id });
  };

  _onSelectLeaf = e => {
    const { onSelect } = this.props;
    const target = e.target.closest(`.${styles.leaf}`);
    const node = target.getAttribute('data-node');
    const parent = target.getAttribute('data-parent');
    onSelect({ selectedSection: parent, selectedLeaf: node });
  };
}
